export enum PAYMENT_METHODS {
    CREDIT_CARD = 'CREDIT_CARD',
    BOLETO = 'BOLETO',
    PIX = 'PIX'
}